import React, { useState, useEffect,useRef} from 'react';
import { configData } from "../config";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import MinicartLength from './MinicartLength';
import ReactDOM from "react-dom/client";
import Loading from './Loading';

function PaypalPaymentNotify() {
    const[searchParams,setSearchParams] = useSearchParams();
    
    const app_url = configData.APP_URL;
    const navigate = useNavigate();
   
    useEffect(()=>{
        PaypalSuccessNotify();
    },[])
   
    async function PaypalSuccessNotify() {
        
      const order_id = localStorage.getItem('order_id');
      const drupal_orderid = localStorage.getItem('drupal_orderid');
      localStorage.removeItem("order_id");
      localStorage.removeItem("drupal_orderid");
      const root = ReactDOM.createRoot(document.getElementById("top-header-cart-icon"));
      root.render(<MinicartLength length={0} />);
      setTimeout(() => {
        navigate("/smww/checkout/thankyou/"+drupal_orderid);
      }, 30000);
     
             
      }
      return (
        <><div style={{ margin: "0 auto",maxWidth: 1170,width: "100%" }}>Please wait until your order is complete.</div><Loading /></>
      );
}

export default PaypalPaymentNotify;